// Used in composite-assignment.component.ts, tiles.component.ts, csv-export.helper.ts, active-assignments-students.component.ts,
// grade-assignments.component.html, evaluate-assignment-details-header.component.html, student-assignments.component.ts

// Angular
import { Injectable } from "@angular/core";

// Services/Types/Helpers
import { ASSIGNED_STATUS } from "#core/string-substitutions/status-names";
import { DueDateStatusHelper } from "#helpers/due-date-status.helper";
import { PPAssignment as Assignment } from "cli-types";

@Injectable()
export class AssignmentStatusHelper {
    private statusBorderColor = "";
    private statusName = "";

    constructor(private dueDateStatusHelper: DueDateStatusHelper) {}

    // get color value for assignment status
    public getStatusColor(assignment: any) {
        // TODO: This should definitely be Assignment, but currently it breaks tiles.
        let status = assignment.status;
        const dueDateStatus = this.getDueDateStatus(assignment);
        if (
            dueDateStatus &&
            !assignment.completedAt &&
            !assignment.evaluatedAt
        ) {
            status = dueDateStatus;
        }
        let color: string;
        switch (status) {
            case "pending":
                color = "var(--color-assigned)";
                break;
            case "dueToday":
                color = "var(--color-due-today)";
                break;
            case "dueThisWeek":
                color = "var(--color-due-today)";
                break;
            case "overdue":
                color = "var(--color-overdue)";
                break;
            case "submitted":
                color = "var(--color-submitted)";
                break;
            case "evaluated":
                color = "var(--color-evaluated)";
                break;
            case "scheduled":
                color = "var(--color-scheduled)";
                break;
            default:
                color = "var(--color-assigned)";
        }
        return color;
    }

    // get color value for assignment status light color
    public getStatusLightColor(status: string) {
        let color: string;
        switch (status) {
            case "pending":
                color = "var(--color-assigned-light)";
                break;
            case "inProgress":
                color = "var(--color-in-progress-light)";
                break;
            case "submitted":
                color = "var(--color-submitted-light)";
                break;
            case "evaluated":
                color = "var(--color-evaluated-light)";
                break;
            case "scheduled":
                color = "var(--color-scheduled-light)";
                break;
            default:
                color = "var(--color-assigned-light)";
        }
        return color;
    }

    public getStatusName(status: string) {
        switch (status) {
            case "pending":
                this.statusName = "Assigned";
                break;
            case "inProgress":
                this.statusName = "In Progress";
                break;
            case "submitted":
                this.statusName = "Submitted";
                break;
            case "evaluated":
                this.statusName = "Evaluated";
                break;
            case "scheduled":
                this.statusName = "Scheduled";
                break;
            default:
                this.statusName = status;
                break;
        }
        return this.statusName;
    }
    public getAllCapsStatusName(status: string) {
        switch (status) {
            case "pending":
                this.statusName = "ASSIGNED";
                break;
            case "inProgress":
                this.statusName = "IN PROGRESS";
                break;
            case "submitted":
                this.statusName = "SUBMITTED";
                break;
            case "evaluated":
                this.statusName = "EVALUATED";
                break;
            case "scheduled":
                this.statusName = "SCHEDULED";
                break;
            default:
                this.statusName = "";
                break;
        }
        return this.statusName;
    }

    // get assignment row status border color
    public getStatusBorderColor(status: string, expanded: boolean) {
        switch (status) {
            case "submitted":
                if (expanded) {
                    this.statusBorderColor = "borderColor-submitted-dim";
                } else {
                    this.statusBorderColor = "borderColor-submitted";
                }
                break;
            case "evaluated":
                if (expanded) {
                    this.statusBorderColor = "borderColor-evaluated-dim";
                } else {
                    this.statusBorderColor = "borderColor-evaluated";
                }
                break;
            default:
                this.statusBorderColor = "";
                break;
        }
        return this.statusBorderColor;
    }

    getAssignedStatus() {
        return ASSIGNED_STATUS;
    }

    // Get correct Due Date Status
    getDueDateStatus(assignment: Assignment) {
        if (assignment) {
            return this.dueDateStatusHelper.getDueDateStatus(assignment);
        }
    }
}
